import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import homeConfig from "src/resources/homePage.json";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";

const MediaCenter = () => {
  const { t } = useTranslation(["common", "homePage"]);
  const mediaCenter = homeConfig.mediaCenter;
  const [value, setValue] = useState(1);

  const moveSlideToPrev = (): void => {
    setValue((prevValue) =>
      prevValue === 1 ? mediaCenter.slides.length : prevValue - 1
    );
  };

  const moveSlideToNext = () => {
    setValue((prevValue) =>
      prevValue === mediaCenter.slides.length ? 1 : prevValue + 1
    );
  };
  return (
    <section className="home-section media-center w-100" id="media-center">
      <div className="main-benefit d-flex">
        <div className="content">
          <h2>{t(`homePage.mediaCenter.title`)}</h2>
          <p>{t(`homePage.mediaCenter.subTitle`)}</p>
        </div>
        <div className="media-center-slider d-flex">
          <ArrowCircleLeftOutlinedIcon
            className="slide-arrow back-arrow"
            onClick={moveSlideToPrev}
          />
          {mediaCenter.slides.map((slide, index) => (
            <div
              key={index}
              className={`slide ${value === index + 1 ? "active" : ""}`}
            >
              <img
                src={require(`src/assets/images/media-center/${slide.name}`)}
                alt={slide.alt}
              />
              <span>
                {t(`homePage.mediaCenter.items.item${index + 1}.title`)}
              </span>
              <p>{t(`homePage.mediaCenter.items.item${index + 1}.content`)}</p>
            </div>
          ))}
          <ArrowCircleRightOutlinedIcon
            className="slide-arrow forward-arrow"
            onClick={moveSlideToNext}
          />
        </div>
      </div>
    </section>
  );
};

export default MediaCenter;
